module.exports = __webpack_public_path__ + "img/solution-msil-function-icon-6.d45b0731.svg";